import { EmptyComponent } from '~/components/Query/utils'
import Table, { type BasisTableProps } from '~/components/Table'

/**
 * A Table that renders the empty state shared by the list queries. Loading is
 * left to the Table itself: the progress bar, and no table until there are
 * rows to put in it.
 */
export default function QueryTable<T>({
  loading,
  data,
  ...rest
}: BasisTableProps<T>) {
  if (!loading && !data?.table?.nodes.length) {
    return <EmptyComponent />
  }

  return <Table<T> {...rest} data={data} loading={loading} />
}
